import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ViewDAT = () => {
  const location = useLocation();
  const nft = location.state?.asset;

  const [selectedEdition, setSelectedEdition] = useState(null);
  const [editionDetails, setEditionDetails] = useState(null);

  const [isCollectionModalVisible, setCollectionModalVisible] = useState(false);
  const [isHoldersModalVisible, setHoldersModalVisible] = useState(false);
  const [isMoreInfoVisible, setMoreInfoVisible] = useState(false);

  const totalUnsoldRoyalties = useMemo(() => {
    if (!nft?.editions) return 0;
    return nft.editions
      .filter((ed) => ed.isForSale)
      .reduce((sum, ed) => sum + (ed.royalties || 0), 0);
  }, [nft]);

  const handleLikePress = () => {
    console.log('Like pressed for NFT:', nft?.id);
  };

  const handleSPNDATPress = () => {
    console.log('SPNDAT pressed for NFT:', nft?.id);
  };

  const handleMoreInfoToggle = () => {
    setMoreInfoVisible(!isMoreInfoVisible);
  };

  const handleViewCollection = () => {
    setCollectionModalVisible(true);
  };

  const handleViewHolders = () => {
    setHoldersModalVisible(true);
  };

  const closeCollectionModal = () => {
    setCollectionModalVisible(false);
  };

  const closeHoldersModal = () => {
    setHoldersModalVisible(false);
  };

  const navigate = useNavigate();
const handleAnalytics = () => {
  navigate('/analytics', {
        state: {
          asset: nft,               // keep if other data is needed
          assetId: nft.id,          // 👈 add
          songName: nft.SongName    // 👈 add
        }
      });   // adjust path if needed
};

  useEffect(() => {
    if (nft && nft.editions && !selectedEdition) {
      const availableEditions = nft.editions.filter((edition) => edition.isForSale);
      const initialEdition =
        availableEditions.length > 0
          ? availableEditions[availableEditions.length - 1]
          : nft.editions[0];
      setSelectedEdition(initialEdition.edition);
      setEditionDetails(initialEdition);
    }
  }, [nft, selectedEdition]);

  const handleEditionClick = (edition) => {
    console.log('Edition clicked:', edition);
    setSelectedEdition(edition.edition);
    setEditionDetails(edition);
    closeCollectionModal();
  };

  const handleProfileClick = (username) => {
    window.location.href = `https://spndat.com/userprofile/${username}`;
  };

  const handleOptionSelect = (option) => {
    console.log('Option selected:', option);
    setMoreInfoVisible(false);
  };

  return (
    <div className="detail-page">
      <div className="artwork-container">
        <img
          src={nft?.ArtworkURL}
          alt={`Artwork for ${nft?.songName}`}
          className="artwork-image pulsating"
        />
      </div>

      <div className="action-buttons">
      <button onClick={handleViewCollection} className="collection-button">
          Collection
        </button>

        <button onClick={handleViewHolders} className="collection-button">
          Holders
        </button>
        <button onClick={handleAnalytics} className="collection-button">
          Analytics
        </button>
      </div>



      {/* Creator Profile moved directly below the buttons */}
      <div className="creator-section">
        <div className="profile" onClick={() => handleProfileClick(nft?.creatorUsername)}>
          <img
            src={nft?.creatorProfileURL || nft?.profileImageUrl}
            alt="Creator"
            className="profile-image-creator"
          />
          <span>@{nft?.creatorUsername}</span>
        </div>
      </div>

      <div className="details">
        <p>
          <strong>DAT:</strong>{' '}
          {nft?.SongName
            ? nft.SongName.charAt(0).toUpperCase() + nft.SongName.slice(1)
            : 'N/A'}
        </p>
        <p>
          <strong>Artist:</strong>{' '}
          {nft?.ArtistName
            ? nft.ArtistName.charAt(0).toUpperCase() + nft.ArtistName.slice(1)
            : 'N/A'}
        </p>
        <p>
          <strong>Tier:</strong>{' '}
          {nft?.tier ? nft.tier.charAt(0).toUpperCase() + nft.tier.slice(1) : 'N/A'}
        </p>
        <p>
          <strong>Available for Ownership:</strong> {totalUnsoldRoyalties}%
        </p>
        <p>
          <strong>Chain:</strong> {nft?.chain || 'N/A'}.com
        </p>
      </div>

      <div className="bottom-section">
        <div className="song-credits-grid">
          <div className="song-credits">
            {nft?.artistFeatures && nft.artistFeatures.length > 0 && (
              <div className="credit-category">
                <h4>Artist Features</h4>
                <ul>
                  {nft.artistFeatures.map((item, index) => (
                    <li key={`af-${index}`}>
                      <span
                        className="credit-link"
                        onClick={() => console.log('Artist Feature clicked:', item)}
                      >
                        {item.tag}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {nft?.producers && nft.producers.length > 0 && (
              <div className="credit-category">
                <h4>Producers</h4>
                <ul>
                  {nft.producers.map((item, index) => (
                    <li key={`prod-${index}`}>
                      <span
                        className="credit-link"
                        onClick={() => console.log('Producer clicked:', item)}
                      >
                        {item.tag}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {nft?.songwriters && nft.songwriters.length > 0 && (
              <div className="credit-category">
                <h4>Songwriters</h4>
                <ul>
                  {nft.songwriters.map((item, index) => (
                    <li key={`sw-${index}`}>
                      <span
                        className="credit-link"
                        onClick={() => console.log('Songwriter clicked:', item)}
                      >
                        {item.tag}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {nft?.recordLabels && nft.recordLabels.length > 0 && (
              <div className="credit-category">
                <h4>Record Labels</h4>
                <ul>
                  {nft.recordLabels.map((item, index) => (
                    <li key={`rl-${index}`}>
                      <span
                        className="credit-link"
                        onClick={() => console.log('Record Label clicked:', item)}
                      >
                        {item.tag}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {nft?.genres && nft.genres.length > 0 && (
              <div className="credit-category">
                <h4>Genres</h4>
                <ul>
                  {nft.genres.map((genre, index) => (
                    <li key={`genre-${index}`}>
                      <span>{genre}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

{isCollectionModalVisible && (
  <div className="modal-overlay" onClick={closeCollectionModal}>
    <div className="modal-content collection-modal" onClick={(e) => e.stopPropagation()}>
      <h2>Collection Editions</h2>
      <ul className="editions-list">
        {nft?.editions &&
          nft.editions.map((edition, index) => (
            <li
              key={index}
              className="edition-item"
              onClick={() => handleEditionClick(edition)}
            >
              <span>
                DAT #{edition.edition} - ${edition.price.toLocaleString()}
              </span>
              <span>
                {edition.isForSale ? `${edition.royalties}%` : 'SOLD'}
              </span>
            </li>
          ))}
      </ul>
      <button onClick={closeCollectionModal} className="close-modal-button">
        Close
      </button>
    </div>
  </div>
)}


      {isHoldersModalVisible && (
        <div className="modal-overlay" onClick={closeHoldersModal}>
          <div className="modal-content holders-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Current Holders</h2>
            <ul className="holders-list">
              {nft?.editions?.filter((ed) => ed.currentOwnerId !== nft?.userId).length === 0 ? (
                <li className="holder-item">There are no current holders</li>
              ) : (
                nft.editions
                  .filter((ed) => ed.currentOwnerId !== nft?.userId)
                  .map((h, idx) => (
                    <li key={idx} className="holder-item">
                      <div
                        className="holder-info"
                        onClick={() => handleProfileClick(h.username)}
                      >
                        <img
                          src={h.profileImageUrl}
                          alt="Holder"
                          className="profile-image"
                        />
                        <span>{h.username}</span>
                      </div>
<span className="holder-edition">#{h.edition} {(h.royalties ?? 0).toFixed(4).replace(/\.?0+$/,'')}%</span>

                    </li>
                  ))
              )}
            </ul>
            <button onClick={closeHoldersModal} className="close-modal-button">
              Close
            </button>
          </div>
        </div>
      )}

      {isMoreInfoVisible && (
        <div className="modal-overlay" onClick={() => setMoreInfoVisible(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>More Options</h2>
            <ul className="options-list">
              <li onClick={() => handleOptionSelect('Share to Feed')}>Share to Feed</li>
              <li onClick={() => handleOptionSelect('Copy Link')}>Copy Link</li>
              <li onClick={() => handleOptionSelect('Send in Message')}>Send in Message</li>
            </ul>
            <button onClick={() => setMoreInfoVisible(false)} className="close-modal-button">
              Close
            </button>
          </div>
        </div>
      )}

<style>{`
  :root{
    --brand-top:#fe24ad;
    --brand-bot:#a410e8;
    --brand-grad:linear-gradient(135deg,var(--brand-top),var(--brand-bot));
    --brand-top-20:rgba(254,36,173,.2);
    --brand-bot-30:rgba(164,16,232,.3);
    --brand-bot-45:rgba(164,16,232,.45);
  }

  *{margin:0;padding:0;box-sizing:border-box;}
  body,html{
    font-family:sans-serif;
    background:#000;
    color:#fff;
  }

  .detail-page{
    max-width:1200px;margin:0 auto;padding:2rem;
    animation:fadeInPage 1s ease-in-out;
    background:
      radial-gradient(900px 600px at 15% 10%, var(--brand-top-20), transparent 60%),
      radial-gradient(700px 500px at 85% 90%, var(--brand-bot-30), transparent 60%);
  }
  @keyframes fadeInPage{from{opacity:0;}to{opacity:1;}}

  /* Artwork */
  .artwork-container{text-align:center;margin-bottom:1rem;}
  .artwork-image{
    width:100%;max-width:400px;height:auto;pointer-events:none;border-radius:12px;
    border:2px solid var(--brand-bot-45);
    box-shadow:0 0 24px rgba(164,16,232,.18), 0 10px 30px rgba(0,0,0,.5);
    transition:opacity .5s ease-in-out, transform .25s ease;
  }
  .artwork-image:hover{transform:translateY(-2px);}

  /* Buttons */
  .action-buttons{
    display:flex;justify-content:center;gap:1rem;margin-bottom:1rem;flex-wrap:wrap;
  }
  .collection-button{
    padding:.75rem 1.5rem;border:none;border-radius:10px;cursor:pointer;font-size:16px;
    background:var(--brand-grad);color:#fff;font-weight:700;letter-spacing:.3px;
    box-shadow:0 6px 20px rgba(0,0,0,.45), 0 0 0 1px var(--brand-bot-45) inset;
    transition:filter .2s ease, transform .2s ease;
  }
  .collection-button:hover{filter:brightness(1.06);transform:translateY(-1px);}
  .collection-button:active{transform:translateY(0);}

  /* Creator */
  .creator-section{display:flex;justify-content:center;flex-wrap:wrap;margin-bottom:1rem;}
  .profile{display:flex;flex-direction:column;align-items:center;cursor:pointer;}
  .profile-image{width:50px;height:50px;border-radius:50%;object-fit:cover;margin-bottom:.5rem;border:2px solid var(--brand-top);}
  .profile-image-creator{width:90px;height:90px;border-radius:50%;object-fit:cover;margin-bottom:.5rem;border:2px solid var(--brand-top);}
  .creator-section .profile span{
    font-size:1.25rem;font-weight:700;
    background:var(--brand-grad);-webkit-background-clip:text;background-clip:text;
    -webkit-text-fill-color:transparent;text-shadow:0 0 14px rgba(164,16,232,.25);
  }

  /* Details */
  .details{text-align:center;margin-bottom:1rem;line-height:1.35;}
  .details p{color:rgba(255,255,255,.9);}
  .details p strong{
    background:var(--brand-grad);-webkit-background-clip:text;background-clip:text;
    -webkit-text-fill-color:transparent;
  }

  /* Bottom section / credits */
  .bottom-section{width:100%;max-width:800px;margin:2rem auto 0;padding:1rem;}
  .song-credits-grid{width:100%;}
  .song-credits{display:grid;grid-template-columns:repeat(2,1fr);gap:1.5rem;}
  .credit-category{margin-bottom:.5rem;text-align:center;background:#050008;border:1px solid var(--brand-bot-45);border-radius:10px;padding:.75rem;}
  .credit-category h4{
    margin-bottom:.35rem;
    background:var(--brand-grad);-webkit-background-clip:text;background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .credit-category ul{list-style:none;padding:0;}
  .credit-category li{margin-bottom:.25rem;color:rgba(255,255,255,.85);}
  .credit-link{color:#fff;cursor:pointer;position:relative;}
  .credit-link::after{
    content:"";position:absolute;left:0;bottom:-2px;width:100%;height:2px;
    background:var(--brand-grad);transform:scaleX(0);transform-origin:right;transition:transform .25s ease;
    box-shadow:0 0 10px rgba(254,36,173,.35);
  }
  .credit-link:hover::after{transform:scaleX(1);transform-origin:left;}

  /* Modals */
  .modal-overlay{
    position:fixed;inset:0;background:rgba(0,0,0,.75);
    display:flex;justify-content:center;align-items:center;z-index:1000;
  }
  .modal-content{
    background:#000;color:#fff;padding:1rem;border-radius:12px;width:90%;max-width:420px;
    border:1px solid var(--brand-bot-45);
    box-shadow:0 0 24px rgba(254,36,173,.18), 0 10px 30px rgba(0,0,0,.6);
    animation:fadeInModal .5s ease-in-out;
  }
  .modal-content h2{
    margin:0 0 .5rem 0;
    background:var(--brand-grad);-webkit-background-clip:text;background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .holders-modal{max-height:80vh;overflow-y:auto;}

  .editions-list,.options-list,.holders-list{list-style:none;padding:0;margin-bottom:1rem;}
  .edition-item,.holder-item{
    padding:.65rem;border-bottom:1px solid var(--brand-bot-45);
    display:flex;justify-content:space-between;align-items:center;cursor:pointer;
    transition:background .2s ease;
  }
  .edition-item:hover,.holder-item:hover{background:rgba(254,36,173,.08);}
  .edition-item:last-child,.holder-item:last-child{border-bottom:none;}

  .holder-info{display:flex;align-items:center;gap:10px;cursor:pointer;}
  .holder-edition{font-weight:800;background:var(--brand-grad);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}

  .close-modal-button{
    padding:.6rem 1rem;border:none;border-radius:10px;cursor:pointer;width:100%;
    background:var(--brand-grad);color:#fff;font-weight:700;
    box-shadow:0 0 0 1px var(--brand-bot-45) inset;
  }

  @keyframes fadeInModal{from{opacity:0;transform:translateY(20px);}to{opacity:1;transform:translateY(0);}}

  @media (max-width:600px){
    .detail-page{padding:1rem;}
    .artwork-image{max-width:100%;border-radius:10px;}
    .song-credits{grid-template-columns:1fr;}
      .modal-overlay{ padding: 12px; }

  /* make the collection modal shorter on mobile and let its middle scroll */
  .collection-modal{
    width: 100%;
    max-width: 420px;
    max-height: 88vh;            /* keeps it from overflowing the viewport */
    display: flex;
    flex-direction: column;
    padding: 0.85rem;
  }

  /* the list becomes the scrollable area inside the modal */
  .collection-modal .editions-list{
    flex: 1;
    min-height: 0;               /* important for flex children to shrink */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 0.8rem;      /* spacing above the Close button */
  }

  /* keep heading tight on mobile */
  .collection-modal h2{
    margin-bottom: 0.5rem;
  }
  }

  /* Pulse */
  @keyframes softPulse{0%{transform:scale(.96);}50%{transform:scale(1);}100%{transform:scale(.96);}}
  .pulsating{animation:softPulse 1s ease-out infinite;will-change:transform;}
`}</style>

    </div>
  );
};

export default ViewDAT;
